import whenDomReady from 'when-dom-ready';

function initialize() {
  const containers = Array.from(document.querySelectorAll('[data-hover-container]'));

  const ACTIVE = 'is-active-container';
  const HOVERED = 'is-hovered';

  if (!containers) {
    return;
  }

  containers.forEach(container => {
    const elements = Array.from(container.querySelectorAll('[data-hover-element]'));

    elements.forEach(el => {
      el.addEventListener('mouseover', event => {
        if (!event.currentTarget.classList.contains(ACTIVE)) {
          container.classList.add(ACTIVE);
          event.currentTarget.classList.add(HOVERED);
        }
      });

      el.addEventListener('mouseleave', () => {
        container.classList.remove(ACTIVE);
        event.currentTarget.classList.remove(HOVERED);
      });
    });
  });
}

whenDomReady().then(initialize);
